/**
 * 参考图、参考强度
 * */
import { FC } from 'react'
import { InputNumber, Tooltip } from 'antd'
import { MyForm } from '~/components/ui/MyForm'
import { QuestionCircleOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import styles from './ReferTo.module.css'
import { PictureCardUpload } from '~/components/business/PictureCardUpload'
import { MyIcon } from '~/components/ui/MyIcon'
import { MySlider } from '~/components/ui/MySlider'
import { MyRadioButton } from '../../../ui/MyRadioButton'
import { ControlNetPulidMode } from '~/graphqls/types'
import FormLabelImgToTag from './FormLabelImgToTag'

interface IProps {
  scrollId?: string
  radioKey?: string
  // 参考图
  formLabel?: string
  formNotice?: string
  labelExtra?: React.ReactNode
  setUrl?: (url: string) => void
  url?: string
  // 参考强度
  weight?: number
  setWeight?: (weight: number) => void
  weightNotice?: string
  weightTitle?: string
  // 上传图片
  limit?: number
  showInfo?: boolean
  // 强度输入
  min?: number
  max?: number
  step?: number
  precision?: number
  // 角色模式
  showPulidMode?: boolean
  pulidMode?: ControlNetPulidMode
  setPulidMode?: (pulidMode: ControlNetPulidMode) => void
}
const ReferTo: FC<IProps> = ({
  scrollId,
  radioKey,
  formLabel = '参考',
  formNotice,
  setUrl,
  url,
  weight,
  setWeight,
  weightNotice,
  weightTitle,
  limit = 10,
  showInfo = false,
  min = 0,
  max = 100,
  step = 1,
  precision,
  showPulidMode,
  pulidMode,
  setPulidMode,
}) => {
  return (
    <>
      <FormLabelImgToTag
        scrollId={scrollId}
        formLabel={formLabel}
        formNotice={formNotice}
        radioKey={radioKey}
        hasRadio={!!url}
      />
      <MyForm.Item className={classNames(styles.borderLessFormItem, '!mb-3')}>
        <PictureCardUpload
          className={classNames(
            styles.initImageUpload,
            'relative bg-neutral-100 !w-[152px] !h-[152px]'
          )}
          limit={limit}
          showInfo={showInfo}
          dirname="ai_init_image"
          onChange={setUrl}
          value={url}
          showDelete={true}
          onDelete={() => {
            setUrl?.('')
          }}
          icon={
            <span className={classNames('text-neutral-400 w-6 h-6 block')}>
              <MyIcon icon="plussquare" className="text-[24px]" />
            </span>
          }
          label={<></>}
        />
      </MyForm.Item>
      {!!url && (
        <>
          <div className="flex items-center mb-3">
            <span className={classNames('text-neutral-500 w-[120px]')}>
              {weightTitle}{' '}
              {!!weightNotice && (
                <Tooltip
                  placement="topLeft"
                  arrowPointAtCenter
                  title={weightNotice}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              )}
            </span>
            <MySlider
              className="flex-1"
              step={step}
              min={min}
              max={max}
              value={weight}
              onChange={setWeight}
              tooltip={{ formatter: null }}
            />
            <InputNumber
              min={min}
              max={max}
              step={step}
              precision={precision}
              className={styles.inputNumberGroup}
              value={weight}
              onChange={val => {
                setWeight?.(Number(val))
              }}
            />
          </div>
          {!!showPulidMode && (
            <div className="flex items-center justify-between mb-3">
              <span className={classNames('text-neutral-500 w-[120px]')}>
                角色模式
              </span>
              <MyRadioButton
                list={[
                  { label: '真实', value: ControlNetPulidMode.FIDELITY },
                  { label: '艺术', value: ControlNetPulidMode.EXTREMELY },
                ]}
                value={pulidMode}
                onChange={val => {
                  setPulidMode?.(val as ControlNetPulidMode)
                }}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}
export default ReferTo
